import { render, staticRenderFns } from "./im-quick-reply.vue?vue&type=template&id=0fcbb4b8"
import script from "./im-quick-reply.vue?vue&type=script&lang=js"
export * from "./im-quick-reply.vue?vue&type=script&lang=js"
import style0 from "./im-quick-reply.vue?vue&type=style&index=0&id=0fcbb4b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports